import React, { useEffect, useRef, useState } from "react";
import "../styles/Projects.css";
import { FaExternalLinkAlt } from "react-icons/fa";

const PROJECTS = [
  
  {
    id: 3,
    title: "LeSecret by Zeina",
    description: "E-commerce & branding website for a luxury cosmetics store, featuring product catalog, secure checkout, and responsive design.",
    tech: ["WordPress", "WooCommerce", "E-commerce"],
    image: "lesecret.png",
    link: "https://lesecret-byzeina.com",
  },
  
  {
    id: 2,
    title: "Safqat Web Application",
    description: "Web application for Safqat platform with user dashboard, transactions management, and responsive design for multiple devices.",
    tech: ["ReactJS", "Node.js", "MySQL", "TailwindCSS"],
    image: "safqat.png",
    link: "#",
  },
  {
    id: 4,
    title: "Hair Salon Website",
    description: "Modern website for a hair salon featuring service showcase, about section, customer testimonials, and easy contact options.",
    tech: ["ReactJS", "CSS"],
    image: "hairsalon.png",
    link: "https://beautiful-twilight-cdb928.netlify.app/",
  },
  {
    id: 5,
    title: "Sticks Skin",
    description: "Single-product e-commerce website showcasing a specialised product with a clean layout, optimised product page, and seamless checkout.",
    tech: ["WordPress", "WooCommerce", "E-commerce"],
    image: "sticksskin.png",
    link: "https://sticks-skin.com",
  },
  {
    id: 1,
    title: "Le Luxe D'eden",
    description: "Modern Guesthouse villas website with room details, amenities, gallery, reservations, map location, and social media integration — smooth and responsive layout.",
    tech: ["Wordpress"],
    image: "leluxededen.png",
    link: "https://www.leluxededen.com",
  },
  {
    id: 6,
    title: "Dental Clinic Website",
    description: "Professional dental clinic website featuring service information, doctor profile, and quick contact options with a clean responsive interface.",
    tech: ["HTML", "CSS", "JavaScript"],
    image: "dentalclinic.png",
    link: "https://aquamarine-torte-084dff.netlify.app/",
  },
];

const ProjectCard = ({ project, index }) => {
  const ref = useRef(null);
  const [vis, setVis] = useState(false);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setVis(true); },
      { threshold: 0.12 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const isDisabled = project.link === "#";

  return (
    <div
      ref={ref}
      className={`project-card ${vis ? "project-card--visible" : ""}`}
      style={{ transitionDelay: `${(index % 3) * 110}ms` }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Image */}
      <div className="project-image">
        <img src={project.image} alt={project.title} loading="lazy" />

        {/* overlay on hover */}
        <div className={`project-overlay ${hovered ? "project-overlay--active" : ""}`}>
          {!isDisabled && (
            <a
              href={project.link}
              target="_blank"
              rel="noopener noreferrer"
              className="project-visit-btn"
              aria-label={`Visit ${project.title}`}
            >
              <FaExternalLinkAlt />
              <span>Visit Site</span>
            </a>
          )}
        </div>

        {/* index label */}
        <span className="project-num">
          {String(project.id).padStart(2, "0")}
        </span>
      </div>

      {/* Content */}
      <div className="project-content">
        <h3 className="project-title">{project.title}</h3>
        <p className="project-desc">{project.description}</p>

        <div className="project-footer">
          <div className="project-tech">
            {project.tech.map((t) => (
              <span key={t} className="tech-badge">{t}</span>
            ))}
          </div>

          {!isDisabled && (
            <a
              href={project.link}
              target="_blank"
              rel="noopener noreferrer"
              className="project-link-icon"
              aria-label={`Open ${project.title}`}
            >
              <FaExternalLinkAlt />
            </a>
          )}
        </div>
      </div>

      {/* bottom accent line */}
      <div className="project-card-line" />
    </div>
  );
};

const Projects = () => {
  const ref = useRef(null);
  const [vis, setVis] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setVis(true); },
      { threshold: 0.08 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="projects" id="projects" ref={ref}>
      <div className="about-rule" aria-hidden="true" />

      <div className="projects-container">
        {/* Header */}
        <div className={`projects-header ${vis ? "projects-header--visible" : ""}`}>
          <span className="section-label">// selected work</span>
          <h2 className="section-title">
            Projects that <em>speak</em><br />for themselves
          </h2>
          <div className="divider" />
          <p className="section-subtitle">
            A selection of work highlighting my passion for clean code, smart design,
            and building websites that deliver real, measurable results.
          </p>
        </div>

        {/* Grid */}
        <div className="projects-grid">
          {PROJECTS.map((project, i) => (
            <ProjectCard key={project.id} project={project} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
